import { InitAdminService } from '@app/admin/services';
import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, Validators, FormControl } from '@angular/forms';
import { AlertService, MessageService } from '@app/shared/services';
import { first } from 'rxjs/operators';
import { TypeResponse } from '@app/shared/enum/TypeResponse';
import { GroupNotificationService } from '@app/marketing/services';
import { GroupNotification } from '@app/marketing/model';

@Component({ templateUrl: 'groupNotification.component.html' })
export class GroupNotificationComponent implements OnInit {
  submitted = false;
  public errorMessage = '';
  public listErrorMessage: any[];

  entityForm;
  public editEntity: boolean;
  public validEntity: boolean;
  public entityId: number;

  // :: Change Here ::
  private groupNotification: GroupNotification;
  returnUrl: string = '/marketing/groupnotificationlist';

  constructor(
    private router: Router,
    private formBuilder: FormBuilder,
    private activatedRoute: ActivatedRoute,
    private alertService: AlertService,
    private initAdmin: InitAdminService,
    private loading: MessageService,
    private groupNotificationService: GroupNotificationService
  ) { }
  
  // :: Generic ::
  ngOnInit(): void {
    this.loading.showLoading();
    this.initAdmin.setConfigPage();
    this.returnUrl 
    
    this.activatedRoute.params.subscribe(params => {
      this.entityId = params['id'];
      if (this.entityId > 0) {
        this.editEntity = true;
        this.loadEntityById(this.entityId);
      } else {
        this.editEntity = false;
        this.onInitForm();
      }
    });

    // Check phone valid
    this.onSetEventsForm();

    this.loading.hideLoading();
  }

  // :: Generic ::
  get f() {
    return this.entityForm.controls;
  }

  // :: Generic ::
  onSetEventsForm() {
  }

  // :: Generic ::
  onCancel(): void {
    this.router.navigate([this.returnUrl]);
  }

  // :: Generic ::
  validAfterSubmit(dataReturn) {
    if (dataReturn.typeResponse == TypeResponse.Success) {
      this.validEntity = true;
      this.router.navigate([this.returnUrl]);
    } else {
      this.validEntity = false;
      this.errorMessage = dataReturn.message;
      if (dataReturn.data && dataReturn.data.errors && dataReturn.data.errors.length > 0) {
        this.listErrorMessage = [];
        for (var i = 0; i <= dataReturn.data.errors.length; i++) {
          this.listErrorMessage.push(dataReturn.data.errors[i].Description);
        }
      }
    }
    this.submitted = false;
    this.loading.hideLoading();
  }

  onInitForm() {
    this.validEntity = true;
    this.entityForm = this.formBuilder.group({
      id: [0],
      name: ['', [Validators.required]],
      email: ['', [Validators.required]],
      description: ['', [Validators.required]],
      createdOn: [''],
      updatedOn: ['']
    });
  }

  loadEntityById(id) {
    this.loading.showLoading();
    this.groupNotificationService.getById(id)
    .pipe(first())
    .subscribe(response => {
      if (response.typeResponse == TypeResponse.Success) {
        this.validEntity = true;
        this.entityForm = this.formBuilder.group({
          id: new FormControl(response.data.id),
          name: new FormControl(response.data.name),
          email: new FormControl(response.data.email),
          description: new FormControl(response.data.description),
          createdOn: new FormControl(response.data.createdOn),
          updatedOn: new FormControl(response.data.updatedOn)
        });
      } else {
        this.validEntity = true;
      }
      this.loading.hideLoading();
      }, error => {
        if (error.error.error === 'invalid_token') {
          this.router.navigate(['/auth/login']);
        }
      }
    );
  }

  onSubmit() {
    this.loading.showLoading();
    this.submitted = true;
    this.validEntity = true;
    
    // Errors Cleaning
    this.errorMessage = '';

    // stop here if form is invalid
    if (this.entityForm.invalid) {
      this.loading.hideLoading();
      this.submitted = false;
      this.validEntity = false;
      this.errorMessage = 'Informe todos os campos para continuar.';
      return;
    }

    this.groupNotification = new GroupNotification(this.entityForm.value);
    
    this.groupNotificationService.save(this.groupNotification.id, this.groupNotification, this.editEntity)
    .pipe(first())
    .subscribe(dataReturn => {
      this.validAfterSubmit(dataReturn);
    }, error => {
      this.validEntity = false;
      this.submitted = false;
      this.loading.hideLoading();
      this.errorMessage = error;
    });
  }
}